module.exports = __webpack_public_path__ + "img/xuexiao.74b60be7.jpg";